import React, { useState } from 'react';
import useStyle from './carouselRessources.style';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import {
  ExtenalLinkVariant,
  ExternalLink
} from 'components/atoms/Links/ExternalLink';
import { Icon } from 'components/atoms/Icons';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { trackEvent } from 'services/matomo/trackEvent';

export interface CarouselRessourcesProps {
  links: {
    href: string;
    text: string;
    variant: ExtenalLinkVariant;
    icon: Icon;
    color: string;
  }[];
  onClick: () => void;
}

type Direction = 1 | -1;

export const CarouselRessources = ({
  links,
  onClick
}: CarouselRessourcesProps) => {
  const classes = useStyle();
  const hideArrows = links.length === 1;
  const [currentIndexRessource, setCurrentIndexRessource] = useState(0);
  const changeRessource = (direction: Direction) => {
    const newIndex =
      (currentIndexRessource + direction + links.length) % links.length;
    setCurrentIndexRessource(newIndex);
  };
  const isMobile = useMediaQuery('mobile');

  return (
    <>
      {isMobile ? (
        <div className={classes.root}>
          {links &&
            links.map((e, index) => (
              <ExternalLink
                key={index}
                link={e.href}
                textInside={e.text}
                variant={e.variant}
                icon={e.icon}
                color={e.color}
                onClick={onClick}
              />
            ))}
        </div>
      ) : (
        <div
          className={classes.root}
          onClick={() =>
            trackEvent(
              'Document ressource',
              links[currentIndexRessource].text,
              links[currentIndexRessource].href
            )
          }
        >
          <div className={classes.carousel}>
            {!hideArrows && (
              <IconButton
                variant="backless"
                icon="LeftArrow"
                onClick={() => changeRessource(-1)}
              />
            )}
            <h1 className={classes.text}>{`Ressource n°${currentIndexRessource +
              1}/${links.length}`}</h1>
            {!hideArrows && (
              <IconButton
                variant="backless"
                icon="RightArrow"
                onClick={() => changeRessource(1)}
              />
            )}
          </div>
          {links && (
            <ExternalLink
              key={currentIndexRessource}
              link={links[currentIndexRessource].href}
              textInside={links[currentIndexRessource].text}
              variant={links[currentIndexRessource].variant}
              icon={links[currentIndexRessource].icon}
              color={links[currentIndexRessource].color}
              onClick={onClick}
            />
          )}
        </div>
      )}
    </>
  );
};
